import { Avatar } from '@intercom/surge';
import intercomLogoPath from '@/assets/svgs/intercom-logo.svg';
import { ReportSnapshot } from '@/features/report-snapshots/api/schema';
import { Trans } from '@lingui/react/macro';

export function ReportSnapshotHeader({
  sharedBy,
  title,
  description,
}: {
  sharedBy: ReportSnapshot['sharedBy'];
  title: string;
  description: string | null;
}) {
  return (
    <div className="flex justify-between items-start">
      <div className="flex flex-col py-1 flex-1 min-w-0">
        <h1 className="text-h1 font-semibold">{title}</h1>
        {description && <p className="text-support text-muted pt-1 truncate">{description}</p>}
        <div className="flex flex-row items-center gap-2 pt-1">
          <span className="text-support text-muted">
            <Trans>Shared by:</Trans>
          </span>
          <Avatar size="small">
            <Avatar.Image src={sharedBy.avatar} alt="Shared by" />
          </Avatar>
          <span className="text-support text-muted">
            {sharedBy.name?.length ? sharedBy.name : <Trans>Unknown</Trans>}
          </span>
        </div>
      </div>
      <img src={intercomLogoPath} alt="Intercom logo" width="150px" height="24px" />
    </div>
  );
}
